import React from 'react';
import { ICustomError, ICardsMap } from 'types';
import { Icon, IconNames } from 'atoms';
import { errorMessages } from 'constants/common';
import { Popup } from '../Popup';
import { ManualCardInput } from './ManualCardInput';
import { ActionButtonsRow, ActionButton, ActionButtonLabel } from './styles';
import { ErrorMessage } from '../PopupVerification/styles';

interface IProps {
  onClose: () => void;
  manualInputLoading: boolean;
  manualInputError?: ICustomError;
  onSubmitManualInput: (cards: ICardsMap) => void;
  onManualInput: () => void;
  isManualInputSelected: boolean;
  onCloseManualInput: () => void;
  onCancelLastCard: () => void;
  cancelLastCardDisabled?: boolean;
  onRescanAllCards: () => void;
  changeResultError?: ICustomError;
}

export const PopupChangeClassicBacResultComponent = ({
  onClose,
  manualInputLoading,
  manualInputError,
  isManualInputSelected,
  onManualInput,
  onCloseManualInput,
  onSubmitManualInput,
  onCancelLastCard,
  cancelLastCardDisabled,
  onRescanAllCards,
  changeResultError,
}: IProps) =>
  isManualInputSelected ? (
    <ManualCardInput
      loading={manualInputLoading}
      onClose={onCloseManualInput}
      onConfirmClick={onSubmitManualInput}
      error={manualInputError}
    />
  ) : (
    <Popup title="Change result" onClose={onClose} loading={false}>
      <ActionButtonsRow>
        <ActionButton $variant="blue" onClick={onCancelLastCard} $disabled={cancelLastCardDisabled}>
          <Icon name={IconNames.Cancel} />
          <ActionButtonLabel>Cancel last card</ActionButtonLabel>
        </ActionButton>
        <ActionButton $variant="orange" onClick={onRescanAllCards}>
          <Icon name={IconNames.Rescan} />
          <ActionButtonLabel>Re-scan all cards</ActionButtonLabel>
        </ActionButton>
        <ActionButton $variant="green" onClick={onManualInput}>
          <Icon name={IconNames.Cards} />
          <ActionButtonLabel>Manual input card value</ActionButtonLabel>
        </ActionButton>
      </ActionButtonsRow>
      {changeResultError?.status === 601 ? (
        <ErrorMessage>{errorMessages.NotAvailableAction}</ErrorMessage>
      ) : null}
    </Popup>
  );
